var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',[_c('div',[(_vm.showCategories)?_c('CategoryList',{staticClass:"max-w-6xl mx-auto xl:px-10",attrs:{"categories":_vm.categories}}):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"w-full",attrs:{"id":"blogShell"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }